var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',_vm._g(_vm._b({ref:"quill",attrs:{"value":_vm.value,"options":_vm.editorOption},on:{"input":_vm.onInput,"blur":function($event){return _vm.onEditorBlur($event)},"focus":function($event){return _vm.onEditorFocus($event)},"ready":function($event){return _vm.onEditorReady($event)}}},'quill-editor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }